








































































































































































import Vue from "vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { User } from "@/shared/interfaces/user/User.interface";
import iwMyClassifiedsCriteria from "@/myImmoweb/filters/myClassifiedsCriteria.vue";
import iwTransactionFilter from "@/myImmoweb/filters/TransactionFilter.vue";
import iwStatusFilter from "@/myImmoweb/filters/StatusFilter.vue";
import iwPropertyTypeFilter from "@/myImmoweb/filters/PropertyTypeFilter.vue";
import iwImmowebCodeSearch from "@/myImmoweb/filters/ImmowebCodeSearch.vue";
import iwClassifiedsList from "@/myImmoweb/components/ClassifiedsList.vue";
import iwClassifiedsEmptyState from "@/myImmoweb/components/ClassifiedsEmptyState.vue";
import iwClassifiedsErrorState from "@/myImmoweb/components/ClassifiedsErrorState.vue";
import iwDeactivateModal from "./DeactivateModal.vue";
import iwDeleteModal from "./DeleteModal.vue";
import iwReactivateModal from "./ReactivateModal.vue";
import iwMasqueradeModal from "./MasqueradeModal.vue";
import iwSortByData from "@/myImmoweb/filters/SortByData.vue";
import { ALL_PROPERTY_TYPES, ALL_TRANSACTION_TYPES, ALL_STATUS_CLASSIFIED } from "@/shared/scripts/helpers/constants/classifiedTypes";

import "@/assets/sass/myImmoweb/myImmoweb.scss";

export default Vue.extend({
    components: {
        iwTransactionFilter: iwTransactionFilter,
        iwStatusFilter: iwStatusFilter,
        iwPropertyTypeFilter: iwPropertyTypeFilter,
        iwImmowebCodeSearch: iwImmowebCodeSearch,
        iwClassifiedsList: iwClassifiedsList,
        iwClassifiedsEmptyState: iwClassifiedsEmptyState,
        iwClassifiedsErrorState: iwClassifiedsErrorState,
        iwDeactivateModal: iwDeactivateModal,
        iwDeleteModal: iwDeleteModal,
        iwReactivateModal: iwReactivateModal,
        iwMasqueradeModal: iwMasqueradeModal,
        iwSortByData: iwSortByData,
        iwMyClassifiedsCriteria: iwMyClassifiedsCriteria
    },

    beforeRouteLeave: function(to, from, next) {
        if (!to.meta?.authRequired) {
            this.$store.commit("ModalModule/closeLoginModal");
        }
        next();
    },

    data: function() {
        return {
            isMobile: true as boolean,
            propertyFilterValue: ALL_PROPERTY_TYPES as Array<string>,
            transactionFilterValue: ALL_TRANSACTION_TYPES as Array<string>,
            statusFilterValue: ALL_STATUS_CLASSIFIED as Array<string>,
            isMobileCriteriaOverlayOpen: false as boolean
        };
    },

    computed: {
        ...(mapState("UserModule", ["user"]) as { user: () => User }),
        ...(mapState("MyClassifiedsModule", ["isLoading", "hasError"]) as {
            isLoading: () => boolean,
            hasError: () => boolean
        }),
        ...mapGetters({
            myClassifieds: "MyClassifiedsModule/filteredClassifieds",
            isLogged: "UserModule/isLogged",
            isMasquerading: "UserModule/isMasquerading",
        }),
        isDeactivateModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isDeactivateModalOpen"];
        },
        isReactivateModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isReactivateModalOpen"];
        },
        optimizedEncodingUrl: function(): string {
            return this.$t("route-optimized-encoding") as string;
        }
    },

    watch: {
        isLogged: function(nowLogged) {
            if (nowLogged) {
                this.fetchClassifieds();
            }
        }
    },

    created: function() {
        if (this.$route?.meta?.authRequired && !this.isLogged) {
            this.$store.commit("ModalModule/setCanBeClose", false);
            this.$store.commit("ModalModule/openLoginModal");
        }
        this.$store.dispatch("FormModule/resetCriteria");
        this.$store.commit("CustomersModule/resetCustomer");
        this.$store.commit("PicturesModule/setPictures", []);
    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });

        if (this.isLogged) {
            this.fetchClassifieds();
        }
        this.pollNow();
    },

    beforeDestroy: function() {
        this.clearPollNow();
    },

    methods: {
        ...mapActions({
            fetchClassifieds: "MyClassifiedsModule/fetchClassifieds",
            pollNow: "Time/pollNow",
            clearPollNow: "Time/clearPollNow",
            resetValidatedSteps: "StepsWizard/reset",
        }),
        editClassified: function(id: string) {
            if (this.$store.getters["MyClassifiedsModule/getClassifiedById"](id)) {
                const urlTranslated = this.$t("step-property-type") as string;
                const to = this.$router.resolve({ path: urlTranslated + id });
                this.$router.push(to.location);
            }
        },
        formatDate: function(dateString: string) {
            const dateObject = new Date(dateString);
            return dateObject.toLocaleDateString("fr-BE");
        },
        closeDeactivateModal: function() {
            this.$store.commit("ModalModule/closeDeactivateModal");
        },
        closeReactivateModal: function() {
            this.$store.commit("ModalModule/closeReactivateModal");
        },
        openMobileCriteriaOverlay: function() {
            this.isMobileCriteriaOverlayOpen = true;
        },
        closeMobileCriteriaOverlay: function() {
            this.isMobileCriteriaOverlayOpen = false;
        },
        handleFilterButtonClick: function() {
            (this.$refs.myClassifiedsCriteria as Vue & { openMobileOverlay: () => void }).openMobileOverlay();
        },
        handleSortButtonClick: function() {
            const sortCriteria = this.$refs.sortCriteria as Vue;
            if (sortCriteria) {
                (sortCriteria.$refs.dropdownSort as Vue & { openList: () => void }).openList();
            }
        },
        start: function() {
            this.$router.push(this.optimizedEncodingUrl);
        }
    }
});
